import * as scheduleApi from '../api/schedule';
import type { BackendScheduleEvent } from '../api/schedule';
import { KeyedAsyncCache } from './asyncCache';

const bySeason = new KeyedAsyncCache<BackendScheduleEvent[]>(
  async (seasonId) => scheduleApi.listScheduleEventsBySeason(seasonId),
  [],
  'schedule:bySeason',
);

/** The planned calendar for a season — used to show a farmer "which bước
 * (step) are you on" when logging, and to let them explicitly pick one.
 * Returns [] for a season with no CultivationProcess ever applied, which is
 * exactly the signal callers use to hide the step-picker entirely. */
export function getScheduleEventsBySeason(seasonId?: string): BackendScheduleEvent[] {
  if (!seasonId) return [];
  return bySeason.get(seasonId);
}

export function refreshScheduleEventsForSeason(seasonId: string): void {
  bySeason.invalidate(seasonId);
  bySeason.get(seasonId);
}
